import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";
import MDBox from "components/MDBox";
import { navbarRow, navbarMobileMenu } from "examples/Navbars/DashboardNavbar/styles";
import { useMaterialUIController, setMiniSidenav } from "context";

export default function MobileNavbar({ light, isMini }) {
  const [controller, dispatch] = useMaterialUIController();
  const { miniSidenav, transparentNavbar, darkMode } = controller;

  const handleMiniSidenav = () => setMiniSidenav(dispatch, !miniSidenav);

  const iconsStyle = ({ palette: { dark, white, text }, functions: { rgba } }) => ({
    color: () => {
      let colorValue = light || darkMode ? white.main : dark.main;

      if (transparentNavbar && !light) {
        colorValue = darkMode ? rgba(text.main, 0.6) : text.main;
      }

      return colorValue;
    },
  });

  return isMini ? null : (
    <MDBox sx={(theme) => navbarRow(theme, { isMini })}>
      <MDBox color={light ? "white" : "inherit"}>
        <IconButton
          size="small"
          disableRipple
          color="inherit"
          sx={navbarMobileMenu}
          onClick={handleMiniSidenav}
        >
          <Icon sx={iconsStyle} fontSize="medium">
            {miniSidenav ? "menu_open" : "menu"}
          </Icon>
        </IconButton>
      </MDBox>
    </MDBox>
  );
}
